module.exports = __webpack_public_path__ + "static/media/unit 3-13.30d917c5.jpg";